/*
 *
 * @desc: 产品/套餐第三方平台导流配置
 * @author: haifn
 * @time: 2021-09-30 4:9:33
 */

import { CountryCode, getLANG, isEmpty } from '@/utils';

const LANG = getLANG();
/**
 * @param {String} name 产品id对应产品名（开发看）
 * @param {String} url 导流链接
 * @param {Array} enabledCountry 产品导流启用地区，为空则表示所有地区
 * @param {Array} disabledCountry 产品导流禁用地区，为空则表示没有禁用地区
 * @param {Object} commodity 导流产品套餐id，只针对产品下的某个套餐进行导流
 *
 */
const config = {
  'test_pid': {
    name: '示例 - 整个产品导流',
    url: 'https://www.baidu.com',
    enabledCountry: [],
    disabledCountry: [],
  },
  'test_pid_2': {
    name: '示例 - 部分套餐导流',
    commodities: {
      'test_pid_2_cid_1': {
        name: '套餐所有地区导流',
        url: 'https://www.baidu.com',
      },
      'test_pid_2_cid_2': {
        name: '套餐部分地区导流',
        enabledCountry: [
          {
            code: 'CN',
            url: 'https://www.baidu.com',
          },
        ],
      },
    },
  },
  322: {
    name: 'Pro2双肩包',
    url: 'https://bit.ly/insta360-monopole',
    text: LANG['common.btn.third_party.go_to_322'],
  },
  325: {
    name: 'Newbee drone',
    url: 'https://newbeedrone.com/products/invisi360-drone?aff=39',
    text: LANG['common.btn.go_to_newbeedrone'],
  },
  342: {
    name: 'Pro2潜水镜',
    url: 'https://www.mantis-sub.com/affiliate-products//p/mantis-sub-domes-d38cd?aff=4',
    text: LANG['common.btn.third_party.go_to_342'],
  },
  445: {
    name: '一英寸全景潜水壳',
    commodities: {
      2302: {
        name: '套餐所有地区导流',
        url: 'https://www.mantis-sub.com/affiliate-products//p/mantis-rs360-dome-y95mg?aff=4',
        text: LANG['common.btn.third_party.go_to_342'],
      },
    },
  },
  11: {
    name: '台湾GO防水版本',
    commodities: {
      916: {
        name: '套餐部分地区导流',
        enabledCountry: [
          {
            code: 'TW',
            url: 'https://shopee.tw/INSTA360-GO-%E6%8B%87%E6%8C%87%E9%98%B2%E6%8A%96%E7%9B%B8%E6%A9%9F-%E5%85%AC%E5%8F%B8%E8%B2%A8-i.250759446.4031344287?position=1',
          },
        ],
      },
    },
  },
  5: {
    name: '韩国Nanos黑色导流',
    commodities: {
      131: {
        name: '套餐部分地区导流',
        enabledCountry: [
          {
            code: 'KR',
            url: 'https://smartstore.naver.com/insta360/products/5326207137',
            text: '제3자 쇼핑몰',
          },
        ],
      },
    },
  },
  2: {
    name: '台湾Nano银色导流',
    commodities: {
      15: {
        name: '套餐部分地区导流',
        enabledCountry: [
          {
            code: 'TW',
            url: 'https://24h.pchome.com.tw/prod/DGAD8H-A900987US',
          },
        ],
      },
    },
  },
  13: {
    name: 'ONEX2',
    commodities: {
      1168: {
        name: '鸣人 中国台湾、中国香港导流',
        enabledCountry: [
          {
            code: 'HK',
            url: 'https://www.fortress.com.hk/zt/product/one-x2-naruto-edition-360-camera/p/BP_12214840',
          },
          {
            code: 'TW',
            url: 'https://dongcheng.tw/index/product/productinfo.html?id=724',
          },
        ],
      },
      1174: {
        name: '佐助 中国台湾、中国香港导流',
        enabledCountry: [
          {
            code: 'HK',
            url: 'https://www.fortress.com.hk/zt/product/one-x2-naruto-edition-360-camera/p/BP_12214840',
          },
          {
            code: 'TW',
            url: 'https://dongcheng.tw/index/product/productinfo.html?id=725',
          },
        ],
      },
    },
  },
  353: {
    name: 'SMO 360',
    commodities: {
      1670: {
        name: '套餐所有地区导流',
        url: 'https://betafpv.com/products/smo-360-camera?sca_ref=1366923.35JuLFvVGJ',
        text: 'GO TO BETAFPV',
      },
      1671: {
        name: '套餐所有地区导流',
        url: 'https://betafpv.com/products/pavo360-fpv-quadcopter?sca_ref=1366923.35JuLFvVGJ',
        text: 'GO TO BETAFPV',
      },
      1673: {
        name: '套餐所有地区导流',
        url: 'https://betafpv.com/products/pavo360-fpv-quadcopter?sca_ref=1366923.35JuLFvVGJ',
        text: 'GO TO BETAFPV',
      },
      1674: {
        name: '套餐所有地区导流',
        url: 'https://betafpv.com/products/pavo360-fpv-quadcopter?sca_ref=1366923.35JuLFvVGJ',
        text: 'GO TO BETAFPV',
      },
      1675: {
        name: '套餐所有地区导流',
        url: 'https://betafpv.com/products/pavo360-fpv-quadcopter?sca_ref=1366923.35JuLFvVGJ',
        text: 'GO TO BETAFPV',
      },
    },
  },
  14: {
    name: 'GO2',
    commodities: {
      1324: {
        name: '32GB标准套餐',
        enabledCountry: [
          {
            code: 'US',
            url: 'https://www.microcenter.com/product/661220/insta360-go-2-action-camera?ob=1',
          },
          {
            code: 'ID',
            url: 'https://eraspace.com/eraspace/produk/insta360-go2-standard-32gb-white',
          },
          {
            code: 'AU',
            url: 'https://www.anacondastores.com/camping-hiking/lighting-electronics/cameras/insta360-go-2-action-cam/BP90195520-white',
          },
        ],
      },
      1582: {
        name: '64GB标准套餐',
        enabledCountry: [
          {
            code: 'ID',
            url: 'https://eraspace.com/eraspace/produk/insta360-go2-high-capacity-64gb-white',
          },
        ],
      },
      // 1346: {
      //   name: '32GB自拍杆',
      //   enabledCountry: [
      //     {
      //       code: 'AU',
      //       url: 'https://www.amazon.com.au/dp/B097ZQDYDQ?th=1',
      //     },
      //   ],
      // },
    },
  },
};

/**
 * 获取第三方导流产品/套餐的额外信息简介
 * @param pid
 * @param cid
 * @param code
 * @param language
 */
const getExtraIntroConfig = ({ cid, code, language }) => {
  switch (true) {
    case ['TW'].includes(code) && [15].includes(cid):
      return [
        '您將會被引導到第三方購物平台',
        '發貨時間以第三方購物網站實際顯示為準。如有問題請聯絡 service360@drdc.com.tw。',
      ];
    case ['TW'].includes(code) && [1168, 1174].includes(cid):
      return [
        '您將會被引導到第三方購物平台。',
        '發貨時間以第三方購物網站實際顯示為準。如有問題請聯絡 service360@drdc.com.tw。',
      ];
    case ['HK'].includes(code) && [1168, 1174].includes(cid):
      return [
        language === 'zh_tw' ? '您將會被引導到第三方購物平台' : 'You will be directed to Fortress.com.hk.',
        language === 'zh_tw'
          ? '發貨時間以第三方購物網站實際顯示為準。如有問題請聯絡 info@vastworld.com.hk。'
          : "The delivery time is subject to the actual time displayed on the retailer's website. If you have further questions, please contact info@vastworld.com.hk for more info.",
      ];
    default:
      return [];
  }
};

/**
 * @description 判断当前产品套餐是否导流
 * @param {Object} data 套餐
 * @param {Number} data.pid 产品id
 * @param {Number} data.cid 套餐id
 * @returns {{ url: string,text: string }}  url:导流链接 | text:按钮上的文字
 *
 */
function getRedirectData({ pid = '', cid = '' }) {
  const configProduct = config[pid] ?? {};
  const defaultText = LANG['common.btn.go_to_thirdParty_platform']; // 默认文案

  // 非导流产品 - 返回空
  if (isEmpty(configProduct)) {
    return { url: '', text: '' };
  }

  const { commodities: configCommodities, disabledCountry, enabledCountry } = configProduct;

  // 导流整个产品
  if (!configCommodities) {
    if (disabledCountry?.includes(CountryCode)) {
      return { url: '', text: '' };
    }

    if (enabledCountry) {
      if (enabledCountry.includes(CountryCode)) {
        return {
          url: configProduct.url,
          text: configProduct.text || defaultText,
        };
      }
      return { url: '', text: '' };
    }

    return {
      url: configProduct.url,
      text: configProduct.text || defaultText,
    };
  }

  // 只导流部分套餐
  const configCommodity = configCommodities[cid];

  // 非导流套餐
  if (!configCommodity) {
    return {
      url: '',
      text: '',
    };
  } else {
    // 针对部分地区导流套餐
    if (configCommodity.enabledCountry) {
      const countryConfig = configCommodity.enabledCountry.filter((o) => o.code === CountryCode)[0];
      if (countryConfig) {
        return {
          url: countryConfig.url,
          text: countryConfig.text || defaultText,
        };
      } else {
        return {
          url: '',
          text: '',
        };
      }
    } else {
      // 所有地区导流套餐
      return {
        url: configCommodity.url,
        text: configCommodity.text || defaultText,
      };
    }
  }
}

/** 产品页中需要导流的商品map */
const redirectProducts = [
  // link2 & link2c
  {
    // 导流结束时间 北京时间 2025/04/23 17:00:00
    endTime: 1745398800000,
    productId: 29,
    enabledCountryMap: {
      'CA': 'https://www.bestbuy.ca/en-ca/product/insta360-link-2-4k-ai-webcam-cinsabnb/18484188',
      'US': 'https://bestbuy.7tiv.net/N9k4zv',
    },
  },
];

/** 获取产品页中需要导流产品的url */
function getRedirectUrl(productId, code) {
  // 转字符串对比，安全点
  const redirectData = redirectProducts.find((item) => `${productId}` === `${item.productId}`);

  // 没命中商品
  if (!redirectData) return undefined;

  // 时间已下线
  if (Date.now() > redirectData.endTime) return undefined;

  // 当前地区是否导流
  const url = redirectData.enabledCountryMap[code];

  if (!url) return undefined;

  return {
    url,
    endTime: redirectData.endTime,
  };
}

// import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
export default {
  getRedirectData,
  getExtraIntroConfig,
  getRedirectUrl,
};
